export { default } from './MedalShiny'
